export const generateMantineInputPwId = ({
  fieldName,
}: {
  fieldName: string
}): string => `${fieldName}`

export const PW_DEBUG_ENABLED = 'PW_DEBUG_ENABLED'
